import React, { useCallback, useMemo, useState } from "react";
import PropTypes from "prop-types";
import Tooltip from "@mui/material/Tooltip";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import DraggableDialog from "../../common/components/DraggableDialog";
import { Box } from "@mui/system";

const RackNotePopup = ({ row, rnNoteData, selectedDate }) => {
  const [open, setOpen] = useState(false);
  const [matchedNote, setMatchedNote] = useState("");

  const filterData = useCallback(
    (item) =>
      item.rN_RackDefinition_Key === row.rackPricing_RackDefinition_Key &&
      new Date(selectedDate) >= new Date(item.rN_EffDate) &&
      new Date(selectedDate) <= new Date(item.rN_ExpDate),
    [row, selectedDate]
  );

  // Check if there is a matching Rack Note for the given row
  const hasNote = useMemo(
    () => Array.isArray(rnNoteData) && rnNoteData.some(filterData),
    [rnNoteData, filterData]
  );

  // Check and set the matched note
  const checkMatch = () => {
    if (!hasNote) return;

    const match = rnNoteData.find(filterData);

    if (match) {
      setMatchedNote(match.rN_Note);
      setOpen(true);
    }
  };

  // Generate dialog title with product and terminal info
  const getDialogTitle = () => {
    const productDesc =
      row?.rackPricing_FuelProduct_RackDesc || "Unknown Product";
    const terminalDesc =
      row?.rackPricing_Terminal_RackDescription || "Unknown Terminal";
    return `Rack Note for ${productDesc} at ${terminalDesc}`;
  };

  return (
    <>
      <Tooltip title={hasNote ? "View Rack Note" : "No Rack Note"}>
        <span>
          <DriveFileRenameOutlineIcon
            onClick={checkMatch}
            color={hasNote ? "primary" : "disabled"}
            fontSize="small"
            style={{ cursor: hasNote ? "pointer" : "not-allowed" }}
          />
        </span>
      </Tooltip>

      {open && (
        <DraggableDialog
          onClose={() => setOpen(false)}
          title={getDialogTitle()}
          maxWidth="md"
        >
          <Box sx={{ padding: "16px 24px" }}>{matchedNote}</Box>
        </DraggableDialog>
      )}
    </>
  );
};

RackNotePopup.propTypes = {
  row: PropTypes.object.isRequired,
  rnNoteData: PropTypes.array.isRequired,
  selectedDate: PropTypes.string.isRequired,
};

export default RackNotePopup;
